import React, { useContext, useEffect, useState } from "react";
import "./Transaction.css";
import TransactionTableView from "./TransactionTableView";
import searchimg from "../../assets/searchningimg.svg";
import { Context } from "../../services/apiContext";
import configData from "../../utils/config/config.json";
import { useNavigate } from "react-router-dom";
import { useNotificationActionsContext } from "../../components/notificationModal/useModal";
import { getClientIp } from "../../helperFunctions/helperFunctions";
import TabbedView from "../../components/common/TabbedView";
 
export default function Transactions({
  nextStep, prevStep, selectedIpoDetails, goToPage
}) {
  const [opendropdwon, setopendropdwon] = useState(false);
  const [ddlist, setddlist] = useState([]);
  const [transactionsListMaster, setTransactionsListMaster] = useState([]);

  const contextapi = useContext(Context);
  const showAlert = useNotificationActionsContext();
  const navigate = useNavigate();
  const selectedDetails = (that) =>{
    console.log(that);
    navigate('/home/IPO', { state: { summarydataname:that } })
    // history.push("/sipcancelconfirm");
  }
  const [currentTab,setCurrentTab] = useState(1)

  const functioopendropdown = (that) => {
    console.log(opendropdwon);
    setopendropdwon(!opendropdwon);

    if (that != null) {
      setisdatachanged(true);
     
      
      if (that === "All") {
        settransactionsList(transactionsListMaster);
      } else {
        var radiobtn = transactionsListMaster.filter(({ allotment_status }) => allotment_status === that );
        settransactionsList(radiobtn);
      }
    }
  };
  const clearChange = () => {
    setisdatachanged(false);
  };

  // useEffect(() => {
  //   getIPOList();
  //   // getIpoTransactions()
  // }, []);

  useEffect(() => {

    getTransactionData()

  }, [currentTab]);

  const openCancelPage = (that) => {
    selectedIpoDetails(that);
    getIPOdetails(that, 'cancel');
    // 
   
  };

  const openModifyPage = (order) => {
    
    selectedIpoDetails(order);    
    getIPOdetails(order, 'modify');
   
  };

  let combainData = []
  const getIPOdetails = async (txn, type) => {
    console.log(txn)

    var useData = contextapi.getSession("userData").user_key;

    var postData = {
      symbol: txn.symbol,
      user_key: useData,
    };
    var url = "/nse/getipodetails";
    await contextapi
      .postApiAuthCalling(url, postData, true)
      .then((res) => {
        console.log(res);
        if (res[0].status_code === "00") {
          combainData = res[0].IPODetails[0];
          if(res[0].IPODetails[0].Categories[0].Applications.length>0){
            getBidDetails(txn.symbol,txn.appl_refno, type);
          }
          
          // 
          console.log(res);
        } else {
          showAlert({ val: true, msg: res[0].status_desc });
        }
      })
      .catch((error) => {
        showAlert({ val: true, msg: "Something went wrong -" });
      });
  };

  const getBidDetails = async (that,apprefno,type) => {
    var useData = contextapi.getSession("userData").user_key;
    var url = configData.baseURLProxy;
    var postData = {
      data: {
        "user_key":useData,
        "symbol":that,
        "appl_refno":apprefno
      },
      url: configData.baseURLDev + "/user/getbiddetails",
    };
    await contextapi
      .postApiAuthCalling(url, postData)
      .then((res) => {
        console.log(res);
        if (res.msg === "sucess") {
          combainData.BidingDetails = res.data[0].appl_details[0];
          if(type == "modify"){
            goToPage(7,combainData);
          }else {
            goToPage(6,combainData);
          }
         
        }
      })
      .catch((error) => {
        console.log("Error VerifyUser : ", error);
      });

  };



  //API LISTING
  const getIPOList = async () => {
    console.log(transactionsListMaster);

    var useData = contextapi.getSession("userData").user_key;

    var postData = {
      user_key: useData,
    };
    var url = "/nse/getipolist";
    await contextapi
      .postApiAuthCalling(url, postData, true)
      .then((res) => {
        console.log(res);
        if (res[0].status_code === "00") {
          setTransactionsListMaster(res[0].ListofIPOs);
          // StepClick("Open",res[0].ListofIPOs);
        } else {
          showAlert({ val: true, msg: res[0].status_desc });
        }
      })
      .catch((error) => {
        console.log(error);
        // showAlert({ val: true, msg: "Something went wrong" });
      });
  };

  const getTransactionData = async () => {
    var useData = contextapi.getSession("userData").user_key;

    var postData = {
      data: {
        user_key: useData,
        user_ip: await getClientIp(),
        "open_status": currentTab == 1 ? "O" : 'C',

      },
      url: configData.baseURLDev + "/user/ipoTransactionsv2",
    };
    var url = configData.baseURLProxy;
    await contextapi
      .postApiAuthCalling(url, postData, false)
      .then((res) => {
        console.log(res);
        if (res.msg === "sucess") {

          const txn_list = res.data?.[0]?.applns || []

          settransactionsList(txn_list)
          setTransactionsListMaster(txn_list)

          // console.log(dashboardDetails);
        }
      })
      .catch((error) => {
        console.log(error);
        // showAlert({ val: true, msg: "Something went wrong" });
      });
  };
  const [isdatachanged, setisdatachanged] = useState(false);
  const [transactionsList, settransactionsList] = useState([]);

  const [searchbyipo, setsearchbyipo] = useState("");
  const handleInput = (e) => {
    console.log(e);
    setsearchbyipo(e.target.value);
    serachDataFilter(e.target.value);
  };

  const serachDataFilter = (serachText) => {
    let searchData;
    let table;
    table = transactionsListMaster;
    console.log(table);

    if (serachText === "") {
      settransactionsList(table);
    } else {
      searchData = table.filter((data) => {
        if (data.ipo_name.toLowerCase().includes(serachText.toLowerCase())) {
          return true;
        }
      });
      settransactionsList(searchData);
    }
  };
  const [tabPage, settabPage] = useState("");

  return (
    <div id="content">
      <div className="row">

        {/* <div className="col-lg-12 col-md-12 col-12">
          <nav aria-label="breadcrumb" className="hide-md">
            <ol className="breadcrumb--UnorderList">
              <li className="breadcrumb-item">
                <a className="breadcrums">Login</a>
              </li>
              <p className="breadcrumb--Arrow">{">>"}</p>
              <li className="breadcrumb-item" aria-current="page">
                <a className="breadcrums"> Dashboard</a>
              </li>
              <p className="breadcrumb--Arrow">{">>"}</p>
              <li className="breadcrumb-itemActive" aria-current="page">
                Transactions
              </li>
            </ol>
          </nav>
        </div> */}

        <div className="col-lg-12 col-md-12 col-12 addmargin">
          <h5 className="transactionheader">TRANSACTIONS</h5>
          <p className="transactionlabelInfo">
            Retail Investors can purchase application up to 2 lakhs
          </p>
        </div>

        <div className="col-lg-12 col-md-12 col-12 pb-4">
{/* 
          <div className="text-end sort customMargin">
            <div className="searchareaCustom">
              <div className="makeitInputfield">
                <img src={searchimg} alt="searchimg" className="searchImg" />
                <input
                  type="text"
                  placeholder="Search by IPO Name"
                  name="search"
                  className="removeborder"
                  onInput={(e) => handleInput(e)}
                />
                <button className="searchbtn">Search</button>
              </div>
            </div>

            <div className="btn-group">
              <button
                className="btn bordeBtn dropdown-toggle"
                type="button"
                id="defaultDropdown"
                onClick={() => functioopendropdown(null)}
              >
                Sort by
              </button>
              <ul
                className={
                  "dropdown-menu customdropdown " +
                  (opendropdwon == true ? "show" : "")
                }
                aria-labelledby="defaultDropdown"
              >
                <li>
                  <a
                    className="dropdown-item"
                    onClick={() => functioopendropdown("All")}
                  >
                    All Transaction
                  </a>
                </li>
                {ddlist.map((i, index) => (
                  <li key={index}>
                    <a
                      className="dropdown-item"
                      onClick={() => functioopendropdown(i)}
                    >
                      {i}
                    </a>
                  </li>))
                }
              </ul>
            </div>
          </div> */}

        </div>

        
        <TabbedView
            tabs={`Open,Closed`.split(',')}
            tab={currentTab}
            setTab={setCurrentTab}   
        >
 
            <div className="mt-4">

              <TransactionTableView
                data={transactionsListMaster}
                isdatachage={isdatachanged}
                clearChange={clearChange}
                selectedDetails={selectedDetails}
                onModify={openModifyPage}
                onCancel={openCancelPage}

              />
        
            </div>
      
  
        </TabbedView>


        {/* {
          transactionsListMaster.map(tr => 
            <div className="d-flex shadow rounded p-3">
                <p>
                {tr.Name}
                </p>

            </div>
            )
        } */}

      
      </div>
    </div>
  );
}
